export const NOT_AVAILABLE = {code: -1, label:"NOT AVAILABLE"};
export const UNKNOWN = {code: 0, label:"UNKNOWN"};
export const NO_SERVICE = {code: 1, label:"NO SERVICE"};
export const EMERGENCY_ONLY = {code: 2, label:"EMERGENCY ONLY"};
export const SEARCHING = {code: 3, label:"SEARCHING"};
export const BUSY = {code: 4, label:"BUSY"};
export const HOME_NETWORK = {code: 5, label:"HOME NETWORK"};
export const DENIED = {code: 6, label:"DENIED"};
export const ROAMING_INTERNATIONAL = {code: 7, label:"ROAMING INTERNATIONAL"};
export const AIRPLANE = {code: 8, label:"AIRPLANE"};
export const ROAMING_NATIONAL = {code: 9, label:"ROAMING NATIONAL"};
export const ROAMING = {code: 10, label:"ROAMING"};


// WEBPACK FOOTER //
// ./js/core/gateway/service/modules/kpi/converter/enums/NetstatEnum.js